import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_EMPLOYMENTS_START,
} from '../../actions/types'

import {
  updateEmploymentsSuccess,
  updateEmploymentsFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'
import {
  getLoanApplicationId,
  getEmployments,
  getLoanApplicationUser
} from '../../reducers'

function* loanUpdateEmployments(action) {
  const employments = yield select(getEmployments);
  const loanApplicationUser = yield select(getLoanApplicationUser);
  const loanApplicationId = yield select(getLoanApplicationId);
  const current_applicant = loanApplicationUser.flowState === 'employment' ? 'primary' : 'secondary'

  let data = {
    loan_application_user: {
      employments_attributes: employments
    },
    current_applicant
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateEmploymentsSuccess(response))
  } else {
    const entities = current_applicant === 'primary' ? error.response.data.employment : error.response.data.secondaryEmployment

    yield put(updateEmploymentsFailure({
      entities,
      result: Object.keys(entities),
    }))
  }
}

export function* watchLoanUpdateEmployments() {
  yield takeLatest(UPDATE_EMPLOYMENTS_START, loanUpdateEmployments)
}
